export const API_URL = "https://apiservices.unosolindia.com/SSMCommerceNewSupport/SSMCommerceAPI.svc/";

// export const MERCHANT_CODE = "RAASH02009";
export const MERCHANT_CODE = "CHAIB02012";
export const CONTACT_NO = "(070) - 7782 - 9137";
